import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, useTheme } from '@mui/material';
import GitActivity from './GitActivity';
import EventsActivity from './EventsActivity';
import DeviceInsights from './dashboard/DeviceInsights';

const ActivityManagement = () => {
    const theme = useTheme();
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Box sx={{ p: { xs: 2, sm: 3, md: 4, lg: 5 }, bgcolor: 'background.default', minHeight: '100vh' }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
                    Aktivita
                </Typography>
                <Tabs 
                    value={activeTab} 
                    onChange={handleTabChange}
                    sx={{
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 500,
                            minHeight: 48,
                        }
                    }}
                >
                    <Tab label="Udalosti" />
                    <Tab label="Git aktivity" />
                    <Tab label="Zariadenia" />
                </Tabs>
            </Box>

            <Box sx={{ mt: 3 }}>
                {activeTab === 0 && (
                    <EventsActivity />
                )}
                {activeTab === 1 && (
                    <GitActivity />
                )}
                {activeTab === 2 && (
                    <DeviceInsights />
                )}
            </Box>
        </Box>
    );
};

export default ActivityManagement;

